import slick from '@accessible360/accessible-slick';

export const ResourcesAndNews = (() => {
	'use strict';

	let $newsHeaders,
		$featuredMedia,
		$nav,
		buffer;

	function init() {
		$newsHeaders = $('.pxblock--resources-and-news .rn--header'),
		$featuredMedia = $('.posts__FeaturedMedia');
		$nav = $('.pxblock--resources-and-news .rn--nav');
		buffer = 100;

		if($newsHeaders){
			updateNav();
			$(window).on('scroll', updateNav);
		}

		if (!$('body').hasClass('wp-admin') && $featuredMedia.length) {
			initSlider();
		}
	}

	function updateNav(){
		let distScrolled = $(document).scrollTop();
		let $activeHeader = $newsHeaders.first();
		
		$newsHeaders.each(function(i, el){
			let distFromTop = $(el).offset().top - distScrolled;
			if (distFromTop < buffer) {
				$activeHeader = $(el);
			}
		});

		let activeID = '#'+$activeHeader.attr('ID');
		$nav.find('a').removeClass('active');
		$nav.find('a[href="'+activeID+'"]').addClass('active');
	}

	function initSlider(){
		$featuredMedia.slick({
			dots: true,
			arrows: false,
			speed: 1000,
			autoplay: false,
			autoplaySpeed: 0,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					},
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	}

	return {
		init: init,
		name: 'resources-and-news'
	};
})();
